import "../css/cart.css";
import { formatMoney } from "./dom.js";

const parseAmount = (text) =>
  Number(String(text ?? "").replace(/[^0-9.]/g, "")) || 0;

const readSubtotal = () => {
  const rows = [
    ...document.querySelectorAll(".wc-block-components-totals-item"),
  ];
  const subtotalRow = rows.find((row) =>
    /subtotal/i.test(row.textContent ?? ""),
  );
  const amount =
    subtotalRow?.querySelector(".wc-block-components-totals-item__value")
      ?.textContent ??
    document.querySelector(".wc-block-components-totals-item__value")
      ?.textContent ??
    "";
  return parseAmount(amount);
};

const cartHasItems = () =>
  Boolean(
    document.querySelector(
      ".wc-block-cart-items__row, .wc-block-cart-item__wrap",
    ),
  );

const renderDeliveryProgress = () => {
  const sidebar = document.querySelector(
    ".wc-block-cart__sidebar, .wc-block-checkout__sidebar",
  );
  if (!sidebar || !cartHasItems()) {
    document.querySelector(".nanzora-delivery-progress")?.remove();
    return;
  }

  const shipping = window.nanzoraStorefront?.freeShipping ?? {};
  const threshold = Number(shipping.threshold ?? 75);
  const currency = shipping.currency ?? "GBP";
  const numeric = readSubtotal();
  const remaining = Math.max(0, threshold - numeric);
  const unlocked = numeric >= threshold && threshold > 0;

  let container = document.querySelector(".nanzora-delivery-progress");
  if (!container) {
    container = document.createElement("div");
    container.className = "nanzora-delivery-progress";
    const message = document.createElement("p");
    const track = document.createElement("div");
    track.className = "nanzora-progress-track";
    track.setAttribute("aria-hidden", "true");
    const value = document.createElement("span");
    value.className = "nanzora-progress-value";
    track.append(value);
    container.append(message, track);
    sidebar.prepend(container);
  }

  const nextMessage = unlocked
    ? "Free delivery unlocked."
    : `You’re ${formatMoney(remaining, currency)} away from free delivery.`;
  const messageNode = container.querySelector("p");
  if (messageNode && messageNode.textContent !== nextMessage) {
    messageNode.textContent = nextMessage;
  }

  const bar = container.querySelector(".nanzora-progress-value");
  const nextWidth = `${Math.min(100, (numeric / Math.max(threshold, 1)) * 100)}%`;
  if (bar instanceof HTMLElement && bar.style.width !== nextWidth) {
    bar.style.width = nextWidth;
  }
};

let frame = 0;
const scheduleDeliveryProgress = () => {
  window.cancelAnimationFrame(frame);
  frame = window.requestAnimationFrame(renderDeliveryProgress);
};

renderDeliveryProgress();
document.body.addEventListener(
  "wc-blocks_added_to_cart",
  scheduleDeliveryProgress,
);
document.body.addEventListener(
  "wc-blocks_removed_from_cart",
  scheduleDeliveryProgress,
);

const totals = document.querySelector(
  ".wc-block-components-totals-wrapper, .wp-block-woocommerce-cart-totals-block",
);
if (totals) {
  new MutationObserver(scheduleDeliveryProgress).observe(totals, {
    characterData: true,
    childList: true,
    subtree: true,
  });
}

window.nanzoraEmit?.("view_cart");
